module.exports = __webpack_public_path__ + "static/media/trash.2f82c6d3.svg";